// GET routes
export const GET_BATCH_VOLUMES_SUCCESS = 'GET_BATCH_VOLUMES_SUCCESS';
export const GET_BATCH_VOLUMES_FAIL = 'GET_BATCH_VOLUMES_FAIL';

export const GET_BATCH_MEDIA_SUCCESS = 'GET_BATCH_MEDIA_SUCCESS';
export const GET_BATCH_MEDIA_FAIL = 'GET_BATCH_MEDIA_FAIL';

export const GET_BATCH_BULK_DENSITY_SUCCESS = 'GET_BATCH_BULK_DENSITY_SUCCESS';
export const GET_BATCH_BULK_DENSITY_FAIL = 'GET_BATCH_BULK_DENSITY_FAIL';

export const GET_QUENCH_TEAM_VIDEOS_SUCCESS = 'GET_QUENCH_TEAM_VIDEOS_SUCCESS';
export const GET_QUENCH_TEAM_VIDEOS_FAIL = 'GET_QUENCH_TEAM_VIDEOS_FAIL';

export const GET_QUENCH_TEAM_VIDEOS_DATA_SUCCESS = 'GET_QUENCH_TEAM_VIDEOS_DATA_SUCCESS';
export const GET_QUENCH_TEAM_VIDEOS_DATA_FAIL = 'GET_QUENCH_TEAM_VIDEOS_DATA_FAIL';

// POST
export const POST_QUENCH_TEAM_VIDEOS_SUCCESS = 'POST_QUENCH_TEAM_VIDEOS_SUCCESS';
export const POST_QUENCH_TEAM_VIDEOS_FAIL = 'POST_QUENCH_TEAM_VIDEOS_FAIL';

export const POST_QUENCH_TEAM_VIDEOS_DATA_SUCCESS = 'POST_QUENCH_TEAM_VIDEOS_DATA_SUCCESS';
export const POST_QUENCH_TEAM_VIDEOS_DATA_FAIL = 'POST_QUENCH_TEAM_VIDEOS_DATA_FAIL';

export const GET_VOL_AND_BD_AVERAGE_SUCCESS = 'GET_VOL_AND_BD_AVERAGE_SUCCESS';
export const GET_VOL_AND_BD_AVERAGE_FAIL = 'GET_VOL_AND_BD_AVERAGE_FAIL';

export const GET_BIOCHAR_MASS_SUCCESS = 'GET_BIOCHAR_MASS_SUCCESS';
export const GET_BIOCHAR_MASS_FAIL = 'GET_BIOCHAR_MASS_FAIL';

export const GET_BATCH_CARBON_CONTENT_SUCCESS = 'GET_BATCH_CARBON_CONTENT_SUCCESS';
export const GET_BATCH_CARBON_CONTENT_FAIL = 'GET_BATCH_CARBON_CONTENT_FAIL';

export const GET_BIOCHAR_STORED_CARBON_SUCCESS = 'GET_BIOCHAR_STORED_CARBON_SUCCESS';
export const GET_BIOCHAR_STORED_CARBON_FAIL = 'GET_BIOCHAR_STORED_CARBON_FAIL';

// DATA MONITORING ROUTES
// GET routes
export const GET_CB_BATCH_DATA_SUCCESS = 'GET_CB_BATCH_DATA_SUCCESS';
export const GET_CB_BATCH_DATA_FAIL = 'GET_CB_BATCH_DATA_FAIL';

export const GET_CB_ADDITIONAL_BATCH_DATA_SUCCESS = 'GET_CB_ADDITIONAL_BATCH_DATA_SUCCESS';
export const GET_CB_ADDITIONAL_BATCH_DATA_FAIL = 'GET_CB_ADDITIONAL_BATCH_DATA_FAIL';

export const GET_CB_FIELD_NOTES_SUCCESS = 'GET_CB_FIELD_NOTES_SUCCESS'
export const GET_CB_FIELD_NOTES_FAIL = 'GET_CB_FIELD_NOTES_FAIL'

export const GET_CB_IGNITION_FUEL_SUCCESS = 'GET_CB_IGNITION_FUEL_SUCCESS'
export const GET_CB_IGNITION_FUEL_FAIL = 'GET_CB_IGNITION_FUEL_FAIL'

export const GET_CB_EQUIPMENT_TRANSPORT_SUCCESS = 'GET_CB_EQUIPMENT_TRANSPORT_SUCCESS'
export const GET_CB_EQUIPMENT_TRANSPORT_FAIL = 'GET_CB_EQUIPMENT_TRANSPORT_FAIL'

export const POST_CB_IGNITION_FUEL_SUCCESS = 'POST_CB_IGNITION_FUEL_SUCCESS'
export const POST_CB_IGNITION_FUEL_FAIL = 'POST_CB_IGNITION_FUEL_FAIL'

export const POST_CB_EQUIPMENT_TRANSPORT_SUCCESS = 'POST_CB_EQUIPMENT_TRANSPORT_SUCCESS'
export const POST_CB_EQUIPMENT_TRANSPORT_FAIL = 'POST_CB_EQUIPMENT_TRANSPORT_FAIL'

// POST routes
export const POST_VOL_AND_BD_AVERAGE_SUCCESS = 'POST_VOL_AND_BD_AVERAGE_SUCCESS';
export const POST_VOL_AND_BD_AVERAGE_FAIL = 'POST_VOL_AND_BD_AVERAGE_FAIL';

export const POST_BATCH_CARBON_CONTENT_SUCCESS = 'POST_BATCH_CARBON_CONTENT_SUCCESS';
export const POST_BATCH_CARBON_CONTENT_FAIL = 'POST_BATCH_CARBON_CONTENT_FAIL';

export const POST_BIOCHAR_STORED_CARBON_SUCCESS = 'POST_BIOCHAR_STORED_CARBON_SUCCESS';
export const POST_BIOCHAR_STORED_CARBON_FAIL = 'POST_BIOCHAR_STORED_CARBON_FAIL';